export default __webpack_public_path__ + "static/media/city-hall-photo-gallery-negative.1c7d0533.svg";